import Vue from '../main/vue';
import router from '../main/vue-routes';

const loadProductCategory = () => {
  if (document.querySelector('.product-category')) {
    new Vue({
      el: '.product-category',
      comments: true,
      methods: {
        getLink(link) {
          return (
            link +
            (this.$route.params && this.$route.params.parameter
              ? '#!' + this.$route.params.parameter
              : '')
          );
        }
      },
      router
    });
  }
};

export default loadProductCategory;
